import {ProvidersMedicalGuide} from 'domain/usecases';
import {AddressData} from 'presentation/utils';

type HealthGuideCardProps = {
	provider: ProvidersMedicalGuide;
	showTradeName: boolean;
	handleOpenDetails: () => void;
};

type AddressFieldProps = {
	address: AddressData;
};

enum ServiceTypeEnum {
	OFFICES_CLINICS = 'CONSULTORIOS/CLINICAS',
	SUPPORT_SERVICES = 'SERVICOS AUXILIARES DE DIAGNOSTICO E TERAPIA',
}

export {ServiceTypeEnum};
export type {AddressFieldProps, HealthGuideCardProps};
